module.exports = __webpack_public_path__ + "static/img/zhongzhongka5.df16d18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka5.png
// module id = eNfo
// module chunks = 16